import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const MIDDLEWARE_URL = process.env.REACT_APP_API_URL;
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const TVA_PRESETS = [0, 7, 13, 19];

const getCookie = (name) => {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? decodeURIComponent(match[2]) : null;
};

const NAV_SECTIONS = [
  {
    id: "factures", label: "Mes Factures", color: "#6c63ff",
    items: [
      { icon: "🧾", label: "Mes Factures", path: "/home" },
      { icon: "📄", label: "PDF Fiscal",   path: "/home" },
      { icon: "🔍", label: "Traçabilité",  path: "/tracabilite" },
    ],
  },
  {
    id: "monitoring", label: "Monitoring", color: "#5c8df6",
    items: [{ icon: "📡", label: "Dashboard", path: "/dashboard" }],
  },
  {
    id: "avoirs", label: "Avoirs", color: "#e11d48",
    items: [{ icon: "↩️", label: "Avoirs / Crédits", path: "/home" }],
  },
  {
    id: "societe", label: "Ma Société", color: "#f59e0b",
    items: [
      { icon: "✏️", label: "Modifier société", path: "/societes/edit" },
    ],
  },
  {
    id: "settings", label: "Paramètres", color: "#9b59b6",
    items: [{ icon: "👤", label: "Mon Profil", path: "/profile" }],
  },
];

// ─── Searchable Client Dropdown ───────────────────────────────
function ClientSearch({ clients, value, onChange, clientMode, setClientMode, clientLibre, setClientLibre }) {
  const [query, setQuery] = useState("");
  const [open,  setOpen]  = useState(false);
  const ref = useRef(null);

  const selected = clients.find(c =>
    (c.Code || c.CodeClient || c.code || c.id || "") == value
  );
  const displayName = selected
    ? (selected.NomClient || selected.RaisonSociale || selected.nom || selected.name || selected.CodeClient || "")
    : "";
  const filtered = clients.filter(c => {
    const q    = query.toLowerCase();
    const nom  = (c.Nom || c.NomClient || c.RaisonSociale || c.nom || c.name || "").toLowerCase();
    const code = String(c.Code || c.CodeClient || c.code || c.id || "").toLowerCase();
    return !q || nom.includes(q) || code.includes(q);
  }).slice(0, 50);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const handleSelect = (c) => {
    onChange(c.Code || c.CodeClient || c.code || c.id || "");
    setQuery("");
    setOpen(false);
  };

  return (
    <div ref={ref} style={{ position: "relative" }}>

      {/* ── Toggle ── */}
      <div style={{ display:"flex", gap:0, marginBottom:10, border:"1.5px solid #e0e7ff", borderRadius:10, overflow:"hidden", width:"fit-content" }}>
        {[
          { key:"existant",    label:"🏢 Client existant" },
          { key:"occasionnel", label:"✏️ Client occasionnel" },
        ].map(({ key, label }) => (
          <button key={key} type="button"
            onClick={() => { setClientMode(key); if(key==="existant") setClientLibre({nom:"",mf:""}); else onChange(""); }}
            style={{ padding:"8px 18px", border:"none", background: clientMode===key ? "linear-gradient(135deg,#6c63ff,#7c3aed)" : "#fff", color: clientMode===key ? "#fff" : "#64748b", fontSize:13, fontWeight:600, cursor:"pointer", fontFamily:"inherit", borderRight: key==="existant" ? "1.5px solid #e0e7ff" : "none" }}>
            {label}
          </button>
        ))}
      </div>

      {/* ── Mode occasionnel ── */}
      {clientMode === "occasionnel" && (
        <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10 }}>
            <div>
              <label style={{ fontSize:12, fontWeight:600, color:"#374151", display:"block", marginBottom:4 }}>Nom client <span style={{ color:"#dc2626" }}>*</span></label>
              <input placeholder="Ex: Mohamed Ben Ali" value={clientLibre.nom}
                onChange={e => setClientLibre(prev => ({ ...prev, nom: e.target.value }))}
                style={{ ...S.input, fontSize:13 }} />
            </div>
            <div>
              <label style={{ fontSize:12, fontWeight:600, color:"#374151", display:"block", marginBottom:4 }}>Matricule Fiscal <span style={{ color:"#94a3b8", fontWeight:400 }}>(optionnel)</span></label>
              <input placeholder="Ex: 1234567A/P/M/000" value={clientLibre.mf}
                onChange={e => setClientLibre(prev => ({ ...prev, mf: e.target.value }))}
                style={{ ...S.input, fontSize:13 }} />
            </div>
          </div>
          <div style={{ display:"flex", alignItems:"center", gap:8, padding:"8px 12px", background:"#fffbeb", borderRadius:8, border:"1px solid #fde68a" }}>
            <span>💡</span>
            <span style={{ fontSize:11, color:"#92400e" }}>Client non répertorié — sera enregistré comme client occasionnel dans la facture TEIF.</span>
          </div>
        </div>
      )}

      {/* ── Mode existant — dropdown ── */}
      {clientMode === "existant" && (
        <div>
          <div
            style={{ ...S.input, display:"flex", alignItems:"center", cursor:"pointer", background: open ? "#fafaff" : "#fff", borderColor: open ? "#6c63ff" : "#e8e8f0", boxShadow: open ? "0 0 0 3px rgba(108,99,255,.1)" : "none" }}
            onClick={() => { setOpen(!open); setQuery(""); }}
          >
            {value && displayName ? (
              <span style={{ flex:1, fontSize:14, color:"#0f172a" }}>
                {displayName}
                <span style={{ color:"#94a3b8", fontSize:12, marginLeft:6 }}>({value})</span>
              </span>
            ) : (
              <span style={{ flex:1, color:"#94a3b8", fontSize:14 }}>-- Sélectionner un client --</span>
            )}
            <span style={{ color:"#94a3b8", fontSize:12 }}>{open ? "▲" : "▼"}</span>
          </div>

          {open && (
            <div style={{ position:"absolute", top:"calc(100% + 4px)", left:0, right:0, background:"#fff", borderRadius:10, border:"1.5px solid #e0e7ff", boxShadow:"0 8px 32px rgba(108,99,255,0.15)", zIndex:999, maxHeight:280, display:"flex", flexDirection:"column", overflow:"hidden" }}>
              <div style={{ padding:"10px 12px", borderBottom:"1px solid #f0efff" }}>
                <div style={{ display:"flex", alignItems:"center", gap:8, background:"#f8f7ff", borderRadius:8, padding:"0 10px", border:"1px solid #e0e7ff" }}>
                  <span style={{ fontSize:13, color:"#94a3b8" }}>🔍</span>
                  <input autoFocus placeholder="Rechercher client..." value={query}
                    onChange={e => setQuery(e.target.value)}
                    style={{ flex:1, border:"none", outline:"none", background:"transparent", fontSize:13, padding:"8px 0", fontFamily:"inherit", color:"#0f172a" }} />
                  {query && <span onClick={() => setQuery("")} style={{ cursor:"pointer", color:"#94a3b8", fontSize:12 }}>✕</span>}
                </div>
              </div>
              <div style={{ overflowY:"auto", flex:1 }}>
                <div onClick={() => { onChange(""); setOpen(false); setQuery(""); }}
                  style={{ padding:"10px 14px", cursor:"pointer", fontSize:13, color:"#94a3b8", borderBottom:"1px solid #f8fafc" }}
                  onMouseEnter={e => e.currentTarget.style.background = "#f8f7ff"}
                  onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                  -- Aucun client --
                </div>
                {filtered.length === 0 ? (
                  <div style={{ padding:"20px", textAlign:"center", color:"#94a3b8", fontSize:13 }}>Aucun client trouvé</div>
                ) : filtered.map((c, i) => {
                  const nom  = c.Nom || c.NomClient || c.RaisonSociale || c.nom || c.name|| "";
                  const code = c.Code || c.CodeClient || c.code || c.id || "";
                  const isSelected = code == value;
                  return (
                    <div key={i} onClick={() => handleSelect(c)}
                      style={{ padding:"10px 14px", cursor:"pointer", background: isSelected ? "#f0efff" : "transparent", borderLeft: isSelected ? "3px solid #6c63ff" : "3px solid transparent", borderBottom:"1px solid #f8fafc", display:"flex", alignItems:"center", justifyContent:"space-between" }}
                      onMouseEnter={e => { if (!isSelected) e.currentTarget.style.background = "#f8f7ff"; }}
                      onMouseLeave={e => { if (!isSelected) e.currentTarget.style.background = "transparent"; }}
                    >
                      <div>
                        <div style={{ fontSize:13, fontWeight: isSelected ? 700 : 500, color: isSelected ? "#6c63ff" : "#0f172a" }}>
                          {nom || `Client ${code}`}
                        </div>
                        {nom && code && <div style={{ fontSize:11, color:"#94a3b8", marginTop:2 }}>Code: {code}</div>}
                      </div>
                      {isSelected && <span style={{ color:"#6c63ff", fontSize:14 }}>✓</span>}
                    </div>
                  );
                })}
              </div>
              <div style={{ padding:"8px 14px", borderTop:"1px solid #f0efff", fontSize:11, color:"#94a3b8" }}>
                {filtered.length} client{filtered.length !== 1 ? "s" : ""} {query ? "trouvés" : "disponibles"}
              </div>
            </div>
          )}
        </div>
      )}

    </div>
  );
}
// ─── TVA Input (libre + presets) ──────────────────────────────
function TvaInput({ value, onChange }) {
  return (
    <div style={{ display: "flex", gap: 4, alignItems: "center", flexWrap: "wrap" }}>
      <input
        type="number"
        min="0"
        max="100"
        step="0.1"
        value={value}
        onChange={e => onChange(Number(e.target.value))}
        style={{ ...S.input, width: 70, textAlign: "center", fontSize: 13 }}
      />
      <span style={{ fontSize: 12, color: "#64748b", flexShrink: 0 }}>%</span>
      <div style={{ display: "flex", gap: 3 }}>
        {TVA_PRESETS.map(r => (
          <button
            key={r}
            type="button"
            onClick={() => onChange(r)}
            style={{
              padding: "4px 8px", borderRadius: 6, fontSize: 11, fontWeight: 600,
              border: "1.5px solid",
              borderColor: value === r ? "#6c63ff" : "#e8e8f0",
              background: value === r ? "#6c63ff" : "#fff",
              color: value === r ? "#fff" : "#64748b",
              cursor: "pointer", fontFamily: "inherit", transition: "all 0.1s"
            }}
          >
            {r}%
          </button>
        ))}
      </div>
    </div>
  );
}

// ═════════════════════════════════════════════════════════════
function CreateInvoice() {
  const navigate  = useNavigate();
  const location  = useLocation();

  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [clients,    setClients]    = useState([]);
  const [toast,      setToast]      = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [clientMode,  setClientMode]  = useState("existant");
  const [clientLibre, setClientLibre] = useState({ nom: "", mf: "" });

  const userName   = getCookie("name")  || "Utilisateur";
  const societeId  = getCookie("societe_id");
  const [societeNom, setSocieteNom] = useState("LOGIMES");

  useEffect(() => {
    const societe = getCookie("societe");
    if (societe) {
      setSocieteNom(societe);
    } else if (societeId) {
      fetch(`${MIDDLEWARE_URL}/companies/${societeId}`, {
        headers: { Authorization: `Bearer ${getCookie("token")}` }
      })
        .then(r => r.json())
        .then(data => {
          const nom = data.name || data.nom;
          if (nom) setSocieteNom(nom);
        })
        .catch(() => {});
    }
  }, [societeId]);

  const [facture, setFacture] = useState({
    numFacture:  "01",
    dateFacture: new Date().toISOString().split("T")[0],
    codeClient:  "",
    timbre:      1,
  });

  const [lignes, setLignes] = useState([
    { description: "", quantite: 1, prixUnitaire: 0, tva: 19 },
  ]);

  const authHeaders = () => ({
    "Content-Type": "application/json",
    Authorization: `Bearer ${getCookie("token")}`,
  });

  // Fetch clients + auto-incrément numéro facture
  useEffect(() => {
      const headers = { Authorization: `Bearer ${getCookie("token")}` };

      // ── Clients ──────────────────────────────────────────
      fetch(`${MIDDLEWARE_URL}/clients${societeId ? `?societe_id=${societeId}` : ""}`, { headers })
        .then(r => r.json())
        .then(d => setClients(Array.isArray(d) ? d : d.clients || d.data || []))
        .catch(() => {
          fetch(`${BACKEND_URL}/api/clients`, { headers })
            .then(r => r.json())
            .then(d => setClients(Array.isArray(d) ? d : d.clients || d.data || []))
            .catch(() => setClients([]));
        });

      // ── Auto-incrément numéro facture ────────────────────
          // ── Auto-incrément numéro facture ────────────────────
    fetch(`${MIDDLEWARE_URL}/factures?societe_id=${societeId}&limit=1`, { headers })
        .then(r => r.json())
        .then(d => {
            const factures = d.factures || [];
            if (factures.length > 0) {
                const last    = String(factures[0].NumfactAffich || factures[0].NumFacture || "");
                const numPart = parseInt(last.replace(/\D/g, ""));
                if (!isNaN(numPart)) {
                    const prefix = last.match(/^[A-Za-z]*/)?.[0] || "";
                    const next   = numPart + 1;
                    setFacture(prev => ({ ...prev, numFacture: `${prefix}${String(next).padStart(2, "0")}` }));
                }
            } else {
                // Aucune facture existante pour cette société → on démarre à 01
                setFacture(prev => ({ ...prev, numFacture: "01" }));
            }
        })
        .catch(() => {
            setFacture(prev => ({ ...prev, numFacture: "01" }));
        });
    }, []);

  // Calculs
  const montantHT  = lignes.reduce((s, l) => s + l.quantite * l.prixUnitaire, 0);
  const montantTVA = lignes.reduce((s, l) => s + (l.quantite * l.prixUnitaire * l.tva) / 100, 0);
  const montantTTC = montantHT + montantTVA + Number(facture.timbre);

  const handleFactureChange = (e) => setFacture({ ...facture, [e.target.name]: e.target.value });

  const handleLigneChange = (i, field, value) => {
    const updated = [...lignes];
    updated[i] = { ...updated[i], [field]: field === "description" ? value : Number(value) };
    setLignes(updated);
  };

  const addLigne    = () => setLignes([...lignes, { description: "", quantite: 1, prixUnitaire: 0, tva: 19 }]);
  const removeLigne = (i) => lignes.length > 1 && setLignes(lignes.filter((_, idx) => idx !== i));

  const showToast = (msg, type = "success") => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3500);
  };

const handleSubmit = async () => {
  if (clientMode === "existant" && !facture.codeClient) {
    showToast("Veuillez sélectionner un client", "error"); return;
  }
  if (clientMode === "occasionnel" && !clientLibre.nom.trim()) {
    showToast("Veuillez saisir le nom du client", "error"); return;
  }
  if (lignes.some(l => !l.description || l.prixUnitaire <= 0)) {
    showToast("Remplissez toutes les lignes de la facture", "error"); return;
  }
  setSubmitting(true);
  try {
    const payload = {
      ...facture, lignes,
      montantHT:     montantHT.toFixed(3),
      montantTVA:    montantTVA.toFixed(3),
      montantTTC:    montantTTC.toFixed(3),
      codeClient:     clientMode === "existant"    ? facture.codeClient     : null,
      nomClientLibre: clientMode === "occasionnel" ? clientLibre.nom.trim() : null,
      mfClientLibre:  clientMode === "occasionnel" ? clientLibre.mf.trim()  : null,
    };
    const r = await fetch(`${BACKEND_URL}/api/auth/factures`, {
      method: "POST", headers: authHeaders(), body: JSON.stringify(payload),
    });
    if (r.ok) {
      showToast("✅ Facture créée avec succès !");
      setTimeout(() => navigate("/home"), 1500);
    } else {
      showToast("Erreur lors de la création", "error");
    }
  } catch { showToast("Erreur réseau", "error"); }
  setSubmitting(false);
};

  const handleLogout = () => {
    ["token","role","name","societe_id"].forEach(k =>
      document.cookie = `${k}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`
    );
    navigate("/");
  };

  // TVA presets groupés par taux
  const tvaGroups = TVA_PRESETS.filter(r => r > 0).map(rate => {
    const base = lignes.filter(l => l.tva === rate).reduce((s, l) => s + l.quantite * l.prixUnitaire, 0);
    return { rate, base, tva: (base * rate) / 100 };
  }).filter(g => g.base > 0);

  return (
    <div style={S.root}>
      <style>{css}</style>

      {/* ════ SIDEBAR ════ */}
      <aside style={{ ...S.sidebar, width: sidebarCollapsed ? 60 : 224 }}>
        <div style={S.brand} onClick={() => navigate("/home")}>
          <div style={S.brandMark}><span>⚡</span></div>
          {!sidebarCollapsed && <span style={S.brandName}>{societeNom}</span>}
        </div>
        <button style={S.collapseBtn} onClick={() => setSidebarCollapsed(!sidebarCollapsed)}>
          {sidebarCollapsed ? "→" : "←"}
        </button>
        <nav style={S.sidebarNav}>
          <div style={{ ...S.navItem, color:"#64748b" }} className="nav-hover" onClick={() => navigate("/home")}>
            <span style={S.navIcon}>🏠</span>
            {!sidebarCollapsed && <span style={S.navLabel}>Accueil</span>}
          </div>
          <div style={{ ...S.navItem, background:"#6c63ff18", color:"#6c63ff", borderLeft:"3px solid #6c63ff" }}>
            <span style={S.navIcon}>✏️</span>
            {!sidebarCollapsed && <span style={S.navLabel}>Nouvelle Facture</span>}
          </div>
          {NAV_SECTIONS.map(sec => (
            <div key={sec.id}>
              {!sidebarCollapsed && (
                <div style={{ ...S.sectionLabel, color: sec.color }}>
                  <span style={{ ...S.sectionDot, background: sec.color }} />{sec.label}
                </div>
              )}
              {sidebarCollapsed && <div style={S.sectionDivider} />}
              {sec.items.map(item => (
                <div key={item.label}
                  style={{ ...S.navItem, color:"#64748b", borderLeft:"3px solid transparent" }}
                  className="nav-hover"
                  onClick={() => navigate(item.path)}
                  title={sidebarCollapsed ? item.label : ""}>
                  <span style={S.navIcon}>{item.icon}</span>
                  {!sidebarCollapsed && <span style={S.navLabel}>{item.label}</span>}
                </div>
              ))}
            </div>
          ))}
        </nav>
        <div style={S.sidebarFooter}>
          {!sidebarCollapsed && (
            <div style={S.userCard}>
              <div style={S.userInitials}>{(userName || "U").charAt(0).toUpperCase()}</div>
              <div style={S.userMeta}>
                <div style={S.userNameText}>{userName}</div>
                <div style={S.userRoleTag}>👤 Utilisateur</div>
              </div>
            </div>
          )}
          <button style={S.logoutBtn} className="logout-hover" onClick={handleLogout} title="Déconnexion">
            🚪 {!sidebarCollapsed && "Déconnexion"}
          </button>
        </div>
      </aside>

      {/* ════ MAIN ════ */}
      <main style={{ ...S.main, marginLeft: sidebarCollapsed ? 60 : 224 }}>
        <header style={S.header}>
          <div>
            <div style={S.headerEyebrow}>Espace Utilisateur · {societeNom}</div>
            <h1 style={S.headerTitle}>✏️ Créer une nouvelle facture</h1>
          </div>
          <div style={{ display:"flex", gap:10 }}>
            <button onClick={() => navigate("/home")} style={S.btnSecondary}>← Retour</button>
            <button onClick={handleSubmit} disabled={submitting}
              style={{ ...S.btnPrimary, opacity: submitting ? 0.7 : 1 }}>
              {submitting ? "⏳ Enregistrement..." : "💾 Enregistrer Facture"}
            </button>
          </div>
        </header>

        <div style={S.content}>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 360px", gap:24, alignItems:"start" }}>

            {/* LEFT */}
            <div style={{ display:"flex", flexDirection:"column", gap:20 }}>

              {/* INFOS GÉNÉRALES */}
              <div style={S.card}>
                <div style={S.cardHeader}>
                  <span style={S.cardIcon}>📋</span>
                  <h2 style={S.cardTitle}>Informations générales</h2>
                </div>
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16 }}>
                  <Field label="Numéro Facture" required>
                    <input name="numFacture" value={facture.numFacture} onChange={handleFactureChange} style={S.input} />
                  </Field>
                  <Field label="Date Facture" required>
                    <input type="date" name="dateFacture" value={facture.dateFacture} onChange={handleFactureChange} style={S.input} />
                  </Field>
                  <Field label="Client" required style={{ gridColumn:"1/-1" }}>
                    <ClientSearch
                      clients={clients}
                      value={facture.codeClient}
                      onChange={val => setFacture({ ...facture, codeClient: val })}
                      clientMode={clientMode}
                      setClientMode={setClientMode}
                      clientLibre={clientLibre}
                      setClientLibre={setClientLibre}
                    />
                    {clients.length > 0 && (
                      <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 4 }}>
                        {clients.length} client{clients.length !== 1 ? "s" : ""} disponible{clients.length !== 1 ? "s" : ""}
                      </div>
                    )}
                  </Field>
                  <Field label="Timbre Fiscal (TND)">
                    <input type="number" name="timbre" value={facture.timbre}
                      onChange={handleFactureChange} step="0.001" min="0" style={{ ...S.input, maxWidth: 160 }} />
                  </Field>
                </div>
              </div>

              {/* LIGNES */}
              <div style={S.card}>
                <div style={{ ...S.cardHeader, justifyContent:"space-between" }}>
                  <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                    <span style={S.cardIcon}>📦</span>
                    <h2 style={S.cardTitle}>Lignes de facture</h2>
                    <span style={{ background:"#f0efff", color:"#6c63ff", borderRadius:20, padding:"2px 10px", fontSize:12, fontWeight:600 }}>
                      {lignes.length}
                    </span>
                  </div>
                  <button onClick={addLigne} style={{ ...S.btnSecondary, fontSize:12, padding:"6px 14px" }}>
                    + Ajouter ligne
                  </button>
                </div>

                {/* Header colonnes */}
                <div style={{ display:"grid", gridTemplateColumns:"1fr 80px 130px 260px 32px", gap:8, padding:"8px 0", borderBottom:"1px solid #e8e8f0", marginBottom:8 }}>
                {["Description","Qté","Prix HT (TND)","TVA",""].map(h => (
                    <div key={h} style={{ fontSize:11, fontWeight:600, color:"#94a3b8", textTransform:"uppercase", letterSpacing:"0.05em" }}>{h}</div>
                  ))}
                </div>

                {lignes.map((l, i) => (
  <div key={i} className="ligne-row-form" style={{ display:"grid", gridTemplateColumns:"1fr 80px 130px 260px 32px", gap:8, marginBottom:12, alignItems:"center", padding:"6px 8px", margin:"0 -8px 6px", borderRadius:8, borderLeft:"3px solid transparent", transition:"all 0.15s" }}>
                    <input
                      placeholder={`Article / Service ${i+1}`}
                      value={l.description}
                      onChange={e => handleLigneChange(i, "description", e.target.value)}
                      style={{ ...S.input, fontSize:13 }}
                    />
                    <input
                      type="number" min="1" value={l.quantite || ""}
                      placeholder="1"
                      onChange={e => handleLigneChange(i, "quantite", e.target.value)}
                      style={{ ...S.input, fontSize:13, textAlign:"center" }}
                    />
                    <input
                      type="number" min="0" step="0.001" value={l.prixUnitaire || ""}
                      placeholder="0.000"
                      onChange={e => handleLigneChange(i, "prixUnitaire", e.target.value)}
                      style={{ ...S.input, fontSize:13, textAlign:"right", borderColor: l.prixUnitaire <= 0 && l.description ? "#fca5a5" : "#e8e8f0" }}
                    />
                    {/* TVA libre + presets */}
                    <TvaInput
                      value={l.tva}
                      onChange={val => handleLigneChange(i, "tva", val)}
                    />
                    <div style={{ display:"flex", gap:6, marginLeft:8 }}>
  <button
    type="button"
    title="Dupliquer cette ligne"
    onClick={() => setLignes(prev => [...prev.slice(0, i+1), { ...l }, ...prev.slice(i+1)])}
    style={{ width:28, height:32, border:"none", borderRadius:6, background:"#f0efff", color:"#6c63ff", cursor:"pointer", fontSize:13 }}>
    📋
  </button>
  <button
    onClick={() => removeLigne(i)}
    disabled={lignes.length === 1}
    style={{
      width:28, height:32, border:"none", borderRadius:6,
      background: lignes.length===1 ? "#f1f5f9" : "#fee2e2",
      color: lignes.length===1 ? "#cbd5e1" : "#dc2626",
      cursor: lignes.length===1 ? "not-allowed" : "pointer", fontSize:14
    }}>
    ✕
  </button>
</div>
                  </div>
                ))}

                {/* Sous-total lignes */}
                {lignes.some(l => l.prixUnitaire > 0) && (
  <div style={{ marginTop:12, borderTop:"1px dashed #e8e8f0", paddingTop:12 }}>
    {lignes.filter(l => l.prixUnitaire > 0).map((l, i) => {
      const ht  = l.quantite * l.prixUnitaire;
      const tva = (ht * l.tva) / 100;
      const ttc = ht + tva;
      return (
        <div key={i} style={{ display:"flex", justifyContent:"space-between", fontSize:12, color:"#64748b", padding:"3px 0" }}>
          <span>{l.description || `Ligne ${i+1}`} × {l.quantite} — TVA {l.tva}%</span>
          <span style={{ fontWeight: 600 }}>
            {ht.toFixed(3)} HT
            <span style={{ color:"#94a3b8", marginLeft:6 }}>(+{tva.toFixed(3)} TVA)</span>
            <span style={{ color:"#6c63ff", marginLeft:6, fontWeight:700 }}>= {ttc.toFixed(3)} TTC</span>
          </span>
        </div>
      );
    })}
  </div>
)}
              </div>
            </div>

            {/* RIGHT — RÉCAPITULATIF */}
            <div style={{ position:"sticky", top:84 }}>
              <div style={{ ...S.card, border:"2px solid #e0e7ff" }}>
                <div style={S.cardHeader}>
                  <span style={S.cardIcon}>💰</span>
                  <h2 style={S.cardTitle}>Récapitulatif</h2>
                </div>

                <RecapRow label="Montant HT"   value={montantHT.toFixed(3) + " TND"} />
                <RecapRow label="TVA totale"   value={"+ " + montantTVA.toFixed(3) + " TND"} valueColor="#d97706" />
                <RecapRow label="Timbre fiscal" value={"+ " + Number(facture.timbre).toFixed(3) + " TND"} />

                <div style={{ height:1, background:"#e8e8f0", margin:"12px 0" }} />

                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"12px 0" }}>
                  <span style={{ fontWeight:700, fontSize:15, color:"#0f172a" }}>Total TTC</span>
                  <span style={{ fontWeight:800, fontSize:22, color:"#6c63ff" }}>{montantTTC.toFixed(3)} TND</span>
                </div>

                {/* Détail TVA par taux */}
                {tvaGroups.length > 0 && (
                  <div style={{ marginTop:8, padding:14, background:"#f8f7ff", borderRadius:8, border:"1px solid #e0e7ff" }}>
                    <div style={{ fontSize:11, fontWeight:600, color:"#94a3b8", textTransform:"uppercase", marginBottom:8 }}>
                      Détail TVA par taux
                    </div>
                    {tvaGroups.map(g => (
                      <div key={g.rate} style={{ display:"flex", justifyContent:"space-between", fontSize:12, color:"#64748b", padding:"4px 0", borderBottom:"1px solid #f0f0f8" }}>
                        <span>Base TVA {g.rate}% — {g.base.toFixed(3)} TND</span>
                        <span style={{ fontWeight:600, color:"#d97706" }}>+{g.tva.toFixed(3)} TND</span>
                      </div>
                    ))}
                  </div>
                )}

                {/* Client sélectionné */}
                {facture.codeClient && (
                  <div style={{ marginTop:12, padding:12, background:"#f0fdf4", borderRadius:8, border:"1px solid #bbf7d0", fontSize:12 }}>
                    <div style={{ fontWeight:600, color:"#16a34a", marginBottom:4 }}>✅ Client sélectionné</div>
                    <div style={{ color:"#15803d" }}>
                      {(() => {
                        const c = clients.find(x => (x.CodeClient || x.code || x.id) == facture.codeClient);
                        return c ? (c.Nom || c.NomClient || c.RaisonSociale || c.nom || c.name|| facture.codeClient) : facture.codeClient;
                      })()}
                    </div>
                  </div>
                )}

                <button onClick={handleSubmit} disabled={submitting}
                  style={{ ...S.btnPrimary, width:"100%", marginTop:20, padding:"14px", fontSize:15, justifyContent:"center" }}>
                  {submitting ? "⏳ Enregistrement..." : "💾 Enregistrer Facture"}
                </button>
                <button onClick={() => navigate("/home")}
                  style={{ ...S.btnSecondary, width:"100%", marginTop:8, padding:"10px", justifyContent:"center" }}>
                  Annuler
                </button>
              </div>

              <div style={{ marginTop:16, padding:16, background:"#f0fdf4", borderRadius:12, border:"1px solid #bbf7d0" }}>
                <div style={{ fontSize:12, fontWeight:600, color:"#16a34a", marginBottom:6 }}>ℹ️ Facturation TEIF</div>
                <div style={{ fontSize:11, color:"#15803d", lineHeight:1.6 }}>
                  Cette facture sera automatiquement convertie au format TEIF et pourra être soumise à l'ANCE depuis la page Factures.
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* TOAST */}
      {toast && (
        <div style={{
          position:"fixed", bottom:24, right:24, zIndex:2000,
          background: toast.type==="error" ? "#EF4444" : "#0F172A",
          color:"#fff", padding:"12px 20px", borderRadius:10,
          fontSize:13, fontWeight:600, boxShadow:"0 8px 24px rgba(0,0,0,0.2)",
          display:"flex", alignItems:"center", gap:8
        }} className="toast-in">
          {toast.msg}
        </div>
      )}
    </div>
  );
}

// ─── Sub-composants ───────────────────────────────────────────
function Field({ label, required, children, style }) {
  return (
    <div style={{ display:"flex", flexDirection:"column", gap:6, ...style }}>
      <label style={{ fontSize:13, fontWeight:600, color:"#374151" }}>
        {label} {required && <span style={{ color:"#dc2626" }}>*</span>}
      </label>
      {children}
    </div>
  );
}

function RecapRow({ label, value, valueColor = "#475569" }) {
  return (
    <div style={{ display:"flex", justifyContent:"space-between", padding:"10px 0", borderBottom:"1px solid #f1f5f9" }}>
      <span style={{ fontSize:13, color:"#64748b" }}>{label}</span>
      <span style={{ fontSize:13, fontWeight:600, color:valueColor }}>{value}</span>
    </div>
  );
}

// ─── Styles ───────────────────────────────────────────────────
const S = {
  root:          { display:"flex", minHeight:"100vh", background:"#F8FAFC", fontFamily:"'Outfit','Segoe UI',sans-serif", color:"#0F172A" },
  sidebar:       { flexShrink:0, background:"#fff", borderRight:"1.5px solid #ededf5", display:"flex", flexDirection:"column", position:"fixed", top:0, left:0, bottom:0, zIndex:100, transition:"width 0.25s ease", overflow:"hidden", boxShadow:"4px 0 20px rgba(108,99,255,0.06)" },
  brand:         { display:"flex", alignItems:"center", gap:10, padding:"20px 16px 12px", cursor:"pointer", borderBottom:"1px solid #F1F5F9", flexShrink:0 },
  brandMark:     { width:34, height:34, background:"#6c63ff", borderRadius:9, display:"flex", alignItems:"center", justifyContent:"center", fontSize:"1.1rem", flexShrink:0, color:"#fff" },
  brandName:     { fontSize:"1.05rem", fontWeight:800, color:"#6c63ff", whiteSpace:"nowrap" },
  collapseBtn:   { background:"#f0efff", border:"none", color:"#6c63ff", fontSize:"0.75rem", cursor:"pointer", padding:"4px 8px", borderRadius:6, margin:"6px 10px 4px", alignSelf:"flex-end", flexShrink:0 },
  sidebarNav:    { flex:1, overflowY:"auto", padding:"4px 8px" },
  sectionLabel:  { display:"flex", alignItems:"center", gap:6, fontSize:"0.63rem", fontWeight:700, letterSpacing:"0.08em", textTransform:"uppercase", padding:"10px 8px 3px", whiteSpace:"nowrap" },
  sectionDot:    { width:5, height:5, borderRadius:"50%", flexShrink:0 },
  sectionDivider:{ height:1, background:"#ededf5", margin:"6px" },
  navItem:       { display:"flex", alignItems:"center", gap:10, padding:"8px 10px", borderRadius:8, cursor:"pointer", transition:"all 0.15s", marginBottom:1, fontSize:"0.84rem", fontWeight:500, whiteSpace:"nowrap", borderLeft:"3px solid transparent" },
  navIcon:       { fontSize:"0.95rem", width:20, textAlign:"center", flexShrink:0 },
  navLabel:      { overflow:"hidden", textOverflow:"ellipsis" },
  sidebarFooter: { borderTop:"1.5px solid #ededf5", padding:"10px", flexShrink:0 },
  userCard:      { display:"flex", alignItems:"center", gap:8, padding:"8px 10px", borderRadius:10, background:"#F8FAFC", marginBottom:6 },
  userInitials:  { width:30, height:30, borderRadius:"50%", background:"#6c63ff", color:"#fff", display:"flex", alignItems:"center", justifyContent:"center", fontSize:"0.82rem", fontWeight:700, flexShrink:0 },
  userMeta:      { overflow:"hidden" },
  userNameText:  { fontSize:"0.8rem", fontWeight:600, color:"#1a1a2e", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" },
  userRoleTag:   { fontSize:"0.65rem", color:"#94a3b8" },
  logoutBtn:     { display:"flex", alignItems:"center", gap:6, width:"100%", padding:"7px 10px", borderRadius:8, border:"none", background:"#fff0f0", cursor:"pointer", fontSize:"0.78rem", fontWeight:600, color:"#dc2626", fontFamily:"inherit", transition:"all 0.15s" },
  main:          { flex:1, display:"flex", flexDirection:"column", minHeight:"100vh", transition:"margin-left 0.25s ease" },
  header:        { display:"flex", alignItems:"center", justifyContent:"space-between", padding:"16px 32px", background:"#fff", borderBottom:"1.5px solid #ededf5", position:"sticky", top:0, zIndex:50, boxShadow:"0 2px 12px rgba(108,99,255,0.05)" },
  headerEyebrow: { fontSize:"0.68rem", fontWeight:600, letterSpacing:"0.08em", color:"#94A3B8", textTransform:"uppercase", marginBottom:3 },
  headerTitle:   { fontSize:"1.2rem", fontWeight:800, color:"#1a1a2e" },
  content:       { padding:"24px 32px", flex:1 },
  card:          { background:"#fff", borderRadius:14, border:"1px solid #e8e8f0", padding:24, boxShadow:"0 1px 3px rgba(0,0,0,.04)" },
  cardHeader:    { display:"flex", alignItems:"center", gap:10, marginBottom:20 },
  cardIcon:      { fontSize:20 },
  cardTitle:     { fontSize:16, fontWeight:700, color:"#0f172a", margin:0 },
  input:         { width:"100%", height:40, padding:"0 12px", borderRadius:8, border:"1.5px solid #e8e8f0", fontSize:14, background:"#fff", transition:"border-color .15s, box-shadow .15s", color:"#0f172a", fontFamily:"inherit" },
  btnPrimary:    { display:"inline-flex", alignItems:"center", gap:8, padding:"10px 22px", borderRadius:9, border:"none", background:"linear-gradient(135deg,#6c63ff,#7c3aed)", color:"#fff", fontSize:13, fontWeight:700, cursor:"pointer", boxShadow:"0 4px 12px rgba(108,99,255,0.35)", fontFamily:"inherit" },
  btnSecondary:  { display:"inline-flex", alignItems:"center", gap:6, padding:"8px 16px", borderRadius:8, border:"1px solid #E2E8F0", background:"#fff", color:"#334155", fontSize:13, fontWeight:600, cursor:"pointer", fontFamily:"inherit", transition:"all 0.15s" },
};

const css = `
  @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&display=swap');
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { font-family: 'Outfit', sans-serif; }
  ::-webkit-scrollbar { width: 6px; }
  ::-webkit-scrollbar-thumb { background: #c7d2fe; border-radius: 3px; }
  .nav-hover:hover    { background: #f0efff !important; color: #6c63ff !important; }
  .logout-hover:hover { background: #fee2e2 !important; }
  .ligne-row-form:hover { background: #fafaff; border-left-color: #c7d2fe !important; }
  .ligne-row-form:focus-within { background: #f8f7ff; border-left-color: #6c63ff !important; }
  .toast-in { animation: toastIn 0.3s ease; }
  @keyframes toastIn { from { opacity:0; transform:translateY(10px); } to { opacity:1; transform:translateY(0); } }
  input:focus, select:focus { border-color: #6c63ff !important; box-shadow: 0 0 0 3px rgba(108,99,255,.1) !important; outline: none; }
`;

export default CreateInvoice;